import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/event';
import * as schema from '@iichi/schema-database';

export const eventSchema = createSelectSchema(schema.event).extend({
  slug: z.string().regex(/^[A-Z][0-9]{7}$/),
  url: z.url(),
  startAt: z.coerce.date(),
  endAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Event = z.infer<typeof eventSchema>;

export const transformEvent = (data: QueryResult): Event => {
  return eventSchema.parse(data);
};
